import Raven from 'raven-js';
import { AggregateDataReporter } from 'conversations-infrastructure/metrics/AggregateDataReporter';
const PAGE_EVENT_TITLE = 'usage-tracking-stats';
export const buildAggregateDataReporter = () => {
  return new AggregateDataReporter(extra => {
    Raven.capturePageEvent(PAGE_EVENT_TITLE, {
      extra
    });
  });
};